/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable no-extra-boolean-cast */
import { call, put, takeLatest } from 'redux-saga/effects';
import { get, size } from 'lodash';
import { GET_DANH_SACH_DON_HANG, GET_LIST_CHAT_IN_BILL, GET_TOTAL_HEADER_QUAN_LY_DON_HANG, GET_TOTAL_QUAN_LY_DON_HANG, POST_CHAT_IN_BILL, UPDATE_STATUS_ORDER } from './constant';
import { GetQuanLyDonHangActionDone } from './action';
import { getCountHeaderQlDonHangApi, getDanhSachDonHangApi, getListChatBillAPI, getTotalQuanLyDonHangApi, postChatInBillAPI, updateStatusOrderApi } from './helpers';

function* takeGetDanhSachDonHangSaga(action: ActionType): any {
  try {
    action.callback?.onBegin?.()
    const data = yield call(getDanhSachDonHangApi,action.payload);
    if(size(data.data) >= 0 ) {
      action.callback?.onSuccess?.(data.data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
    yield put(GetQuanLyDonHangActionDone(data.data));
  } catch (error) {
    action.callback?.onFail?.(error);
    yield put(GetQuanLyDonHangActionDone([]));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takeUpdateStatusOrderSaga(action: ActionType): any {
  try {
    action.callback?.onBegin?.()
    const data = yield call(updateStatusOrderApi,action.payload);
    if(size(data.data) >= 0 ) {
      action.callback?.onSuccess?.(data.data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}


function* takeGetTotalDanhSachDonHangSaga(action: ActionType): any {
  try {
    action.callback?.onBegin?.();
    const data = yield call(getTotalQuanLyDonHangApi,action.payload);
    if(!!data.data || data.data >= 0) {
      action.callback?.onSuccess?.(data.data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(error);
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takeGetListChatInBillSaga(action: ActionType): any {
  try {
    action.callback?.onBegin?.();
    const data = yield call(getListChatBillAPI,action.payload);
    if(!!data.data || data.data >= 0) {
      action.callback?.onSuccess?.(data.data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takePostChatInBillSaga(action: ActionType): any {
  try {
    action.callback?.onBegin?.()
    const data = yield call(postChatInBillAPI,action.payload);
    if(size(data.data) >= 0 ) {
      action.callback?.onSuccess?.(data.data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takeGetTotalHeaderDanhSachDonHangSaga(action: ActionType): any {
  try {
    action.callback?.onBegin?.();
    const data = yield call(getCountHeaderQlDonHangApi,action.payload);
    if(!!data.data || data.data >= 0) {
      action.callback?.onSuccess?.(data.data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(error);
  } finally {
    action.callback?.onFinish?.()
  }
}

export default function*() {
  yield takeLatest(GET_DANH_SACH_DON_HANG, takeGetDanhSachDonHangSaga);
  yield takeLatest(UPDATE_STATUS_ORDER, takeUpdateStatusOrderSaga);
  yield takeLatest(GET_TOTAL_QUAN_LY_DON_HANG, takeGetTotalDanhSachDonHangSaga);
  yield takeLatest(GET_TOTAL_HEADER_QUAN_LY_DON_HANG, takeGetTotalHeaderDanhSachDonHangSaga);
  ////
  yield takeLatest(GET_LIST_CHAT_IN_BILL, takeGetListChatInBillSaga);
  yield takeLatest(POST_CHAT_IN_BILL, takePostChatInBillSaga);
}

